import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AnnulerClotureButton from './AnnulerClotureButton';

const styles = {
    formControl: {
        marginTop: '20px',
        marginBottom: '20px',
        width: '100%'
    },
    noScrollable: {
        overflowY: 'hidden'
    },
    dialogPaper: {
        maxHeight: '90vh'
    },
};

class ClotureDialog extends React.Component {
    render() {
        const { classes, open, onClose, onClickSave, reclamationId } = this.props;

        return (
            <Dialog
                fullWidth
                maxWidth={'md'}
                classes={{ paper: classes.dialogPaper }}
                open={open}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        onClose(event, reason)
                    }
                }}
            >
                <DialogTitle>
                    Annuler la clôture du dossier après-vente {reclamationId}
                </DialogTitle>

                <DialogContent className={classes.noScrollable}>
                    <Typography variant="subtitle1" gutterBottom>Êtes-vous sûr de vouloir annuler la clôture du dossier après-vente {reclamationId} ?</Typography>


                </DialogContent>

                <DialogActions>
                    <Button onClick={onClose} color="primary">Annuler</Button>
                    <AnnulerClotureButton
                        onClick={onClickSave}
                    />
                </DialogActions>

            </Dialog>
        );
    }
}

ClotureDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    reclamationId: PropTypes.number.isRequired,
    onClickSave: PropTypes.func.isRequired
};

export default withStyles(styles)(ClotureDialog);

